import React from 'react'


const Gallery = () => {
  return (
        <ul className="grid-wrapper li_animate list-unstyled mb-0">
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li className="tall"><img src="assets/images/gallery/1.jpg" alt=""/></li>
            <li className="wide"><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li className="tall"><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li className="big"><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li className="wide"><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li className="big"><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li className="tall"><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
            <li><img src="assets/images/gallery/1.jpg" alt="" /></li>
        </ul>
    )
}

export default Gallery